import LinesGraph from './LinesGraph';

export default LinesGraph;
